"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeDefaults = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _headingDefaults = require("./headingDefaults");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var themeDefaults = {
  theme: {
    breakpoints: {
      // 0px-463px    : X-Small devices (portrait phones, portrait e-readers, smaller tablets)
      xs: 0,
      // 464px-743px  : Small devices (landscape phones, landscape e-readers, portrait tablets)
      sm: 464,
      // 744px-983px  : Medium devices (lo-res laptops and desktops, landscape tablets)
      md: 744,
      // 984px-1247px : Large devices (desktops, laptops, big landscape tablets)
      lg: 984,
      // 1248px-MAX   : X-Large devices (hi-res laptops and desktops)
      xl: 1248
    },
    colors: {
      // neutral
      black: '#000000',
      white: '#FFFFFF',
      // gray
      gray1: '#FAFAFA',
      gray2: '#F3F3F3',
      gray3: '#E5E5E6',
      gray4: '#CBCCCD',
      gray5: '#929496',
      gray6: '#7D7F81',
      gray7: '#4B4D4F',
      gray8: '#323334',
      gray9: '#212223',
      // status
      success1: '#007000',
      success2: '#F2F8E6',
      error1: '#C40000',
      error2: '#FCF0F0',
      error3: '#990000',
      warning1: '#C24E14',
      warning2: '#FFFBEB',
      info1: '#196ECF',
      info2: '#EDF3FB',
      foreground: '#424242',
      background: '#F4F4F4',
      // Data Viz
      primaryDvz1: '#15A796',
      primaryDvz2: '#218371',
      primaryDvz3: '#AEE2D5',
      secondaryDvz1: '#C72887',
      secondaryDvz2: '#8C195E',
      secondaryDvz3: '#F6BCDC',
      purpleDvz1: '#8061BC',
      purpleDvz2: '#422C88',
      purpleDvz3: '#D9CFEB',
      tangerineDvz1: '#E4780C',
      tangerineDvz2: '#B85B06',
      tangerineDvz3: '#FFD7B3',
      sapphireDvz1: '#1E82CB',
      sapphireDvz2: '#155C8E',
      sapphireDvz3: '#C4DFF6',
      statusDvz1: '#03AB03',
      statusDvz2: '#007000',
      statusDvz3: '#B7ECB0',
      redDvz1: '#FF1A1A',
      redDvz2: '#C40000',
      redDvz3: '#FEB5B1'
    },
    space: {
      xs: '4px',
      sm: '8px',
      md: '16px',
      lg: '24px',
      xl: '48px'
    },
    sizes: {
      xs: '0px',
      sm: '464px',
      md: '744px',
      lg: '984px',
      xl: '1248px'
    },
    fontSizes: {
      '2xs': '11px',
      xs: '12px',
      sm: '14px',
      md: '16px',
      lg: '18px',
      xl: '20px'
    },
    fontWeights: {
      lighter: 200,
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      xbold: 800
    },
    fonts: {
      code: 'Menlo, Monaco, Lucida Console, monospace',
      markdown: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"'
    }
  },
  css: {
    '.abyss-theme-provider-root': _objectSpread({
      fontFamily: '$primary',
      fontSize: '$md',
      fontWeight: '$normal',
      color: '$foreground',
      ':focus-visible': {
        focusRing: '$interactive1'
      },
      h1: {
        color: '$primary1',
        fontFamily: '$heading',
        fontWeight: '$semibold',
        fontSize: '2.281rem',
        lineHeight: '3rem'
      },
      h2: {
        color: '$primary1',
        fontFamily: '$heading',
        fontWeight: '$semibold',
        fontSize: '2.027rem',
        lineHeight: '3rem'
      },
      h3: {
        color: '$primary1',
        fontFamily: '$heading',
        fontWeight: '$semibold',
        fontSize: '1.802rem',
        lineHeight: '2.25rem'
      },
      h4: {
        color: '$primary1',
        fontFamily: '$primary',
        fontWeight: '$bold',
        fontSize: '1.602rem',
        lineHeight: '2rem'
      },
      h5: {
        color: '$primary1',
        fontFamily: '$primary',
        fontWeight: '$bold',
        fontSize: '1.424rem',
        lineHeight: '2rem'
      },
      h6: {
        color: '$primary1',
        fontFamily: '$primary',
        fontWeight: '$bold',
        fontSize: '1.266rem',
        lineHeight: '1.5rem'
      }
    }, _headingDefaults.headingDefaults)
  }
};
exports.themeDefaults = themeDefaults;